import { Button, Col, Row } from "antd";
import { UserBubble } from "@shared/ui";
import { fallbackString } from "@shared/utils";
import "./section-second-representatives.scss";

interface Representative {
  userId?: string;
  firstName?: string;
  surname?: string;
  middleName?: string;
  position?: string;
}

interface JournalKeeper {
  company?: {
    id?: string;
    fullName?: string;
  };
  authorizedRepresentativesList?: Representative[];
}

interface SectionSecondRepresentativesProps {
  journalKeepersList?: JournalKeeper[];
}

export const SectionSecondRepresentatives = ({
  journalKeepersList = [],
}: SectionSecondRepresentativesProps) => {
  return (
    <div className="section-second-representatives">
      <div className="section-second-representatives__title">
        Представители, уполномоченный на ведение журнала
      </div>
      {journalKeepersList?.map((keeper, index) => {
        const orgRaw = keeper?.company?.fullName || "-";
        const org = orgRaw
          ? `"${String(orgRaw).replace(/^"+|"+$/g, "")}"`
          : "-";

        return (
          <div
            key={keeper?.company?.id || index}
            className="section-second-representatives__section"
          >
            <div className="section-second-representatives__table">
              {keeper?.authorizedRepresentativesList?.length ? (
                keeper.authorizedRepresentativesList.map((rep, repIndex) => {
                  const fullName =
                    `${rep.surname || ""} ${rep.firstName || ""} ${rep.middleName || ""}`.trim();

                  return (
                    <div key={rep.userId || repIndex}>
                      <Row className="section-second-representatives__row">
                        <Col
                          span={8}
                          className="section-second-representatives__label"
                        >
                          ФИО
                        </Col>
                        <Col
                          span={16}
                          className="section-second-representatives__text"
                        >
                          {rep.userId ? (
                            <UserBubble userId={rep.userId}>
                              <Button
                                type="link"
                                style={{ padding: 0, height: "auto" }}
                              >
                                {fallbackString(fullName)}
                              </Button>
                            </UserBubble>
                          ) : (
                            fallbackString(fullName)
                          )}
                        </Col>
                      </Row>

                      <Row className="section-second-representatives__row">
                        <Col
                          span={8}
                          className="section-second-representatives__label"
                        >
                          Организация
                        </Col>
                        <Col
                          span={16}
                          className="section-second-representatives__text"
                        >
                          {fallbackString(org)}
                        </Col>
                      </Row>

                      <Row className="section-second-representatives__row">
                        <Col
                          span={8}
                          className="section-second-representatives__label"
                        >
                          Должность
                        </Col>
                        <Col
                          span={16}
                          className="section-second-representatives__text"
                        >
                          {fallbackString(rep.position)}
                        </Col>
                      </Row>
                    </div>
                  );
                })
              ) : (
                <div className="section-second-representatives__text">—</div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
